// extracted by mini-css-extract-plugin
export default {"card":"timezone-modal_card__G1+gh","caption":"timezone-modal_caption__Gb0qr","btn":"timezone-modal_btn__grFPs","btns":"timezone-modal_btns__6gLBc"};